import ButtonTypes from './buttonTypes';

export const articleStatus = {
  NEW: 'New',
  POSTED: 'Posted',
  ARCHIVE: 'Archive',
  HIDDEN: 'Hidden',
};

export const articleStatusInfo = {
  [articleStatus.NEW]: {
    title: 'New',
    state: ButtonTypes.LIGHT_WARNING
  },
  [articleStatus.POSTED]: {
    title: 'Posted',
    state: ButtonTypes.SUCCESS
  },
  [articleStatus.ARCHIVE]: {
    title: 'Archive',
    state: ButtonTypes.LIGHT_DANGER
  },
  [articleStatus.HIDDEN]: {
    title: 'Hidden',
    state: ButtonTypes.LIGHT_INFO
  },
};

export const articleStatusList = [
  { label: articleStatus.NEW, value: articleStatus.NEW },
  { label: articleStatus.POSTED, value: articleStatus.POSTED },
  { label: articleStatus.ARCHIVE, value: articleStatus.ARCHIVE },
  { label: articleStatus.HIDDEN, value: articleStatus.HIDDEN },
];
